export enum TypeOfContract {
  Indefinite = 'indefinite',
  Temporary = 'iemporary',
}
